"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.CommonAccordion = void 0;

var _commonAccordion = _interopRequireDefault(require("./components/common-accordion"));

exports.CommonAccordion = _commonAccordion["default"];